type Config = {
  element: Element;
  start: number;
  end: number;
  duration: number;
  prefix?: string;
  postfix?: string;
  transformFn?: (value: number) => number | string;
  useDecimals?: boolean;
};

/**
 * @param {Config} obj
 * @param {Element} obj.element element
 * @param {number} obj.start start value
 * @param {number} obj.end end value
 * @param {number} obj.duration animation duration in ms
 * @param {string} [obj.prefix] prefix
 * @param {string} [obj.postfix] postfix
 * @param {(value: number) => number | string} [obj.transformFn] transform function
 * @param {boolean} [obj.useDecimals] use decimals
 */
export const animateValue = ({
  element,
  start,
  end,
  duration,
  prefix = '',
  postfix = '',
  transformFn = value => value,
  useDecimals = false,
}: Config) => {
  let startTimestamp = null;

  if (!element) {
    return;
  }

  const step = timestamp => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    let value = transformFn(progress * (end - start) + start);

    if (!useDecimals) {
      value = Math.floor(Number(value));
    }

    element.innerHTML = `${prefix}${value}${postfix}`;
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
};
